import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";
import Container from "../../components/Container";
import ArticleCard from "../../components/ArticleCard";
import LinksBlock from "../../components/LinksBlock";
import Script from "next/script";
import generateBlogBreadcrumbList from "../../utils/generateBlogBreadcrumbList";

const PageIndex = () => {
  const { basePath } = useRouter();
  const {t} = useTranslation(["common", "blog"]);
  const articles = Object.values(t("blog:articles", {returnObjects: true}));
  const lastIndex = articles.length - 1;

  const breadcrumbJson = generateBlogBreadcrumbList(basePath)

  return (
    <Layout>
      <Meta
        title={t("blog:meta.title")}
        description={t("blog:meta.description")}
      />
      <Script type="application/ld+json" dangerouslySetInnerHTML={{__html: breadcrumbJson}}/>
      <Container className="blog-background">
        <LinksBlock links={[{text: "Home", link: "/"}, {text: "Blog", link: "/blog"}]}/>
        <div className="blog__top-block">
          <h1 className="blog__title">{t("blog:title")}</h1>
          <p className="blog__description">{t("blog:description")}</p>
        </div>
        <div className="blog__articles-block">
          <ArticleCard key={articles[lastIndex].title} text={articles[lastIndex].text[0]}
                       title={articles[lastIndex].title} date={articles[lastIndex].date} isLast={true}
                       image={articles[lastIndex].articleImage} link={articles[lastIndex].link} readMore={t("blog:readMore")}/>
          {articles.reverse().map((article, index) =>
            index !== 0 &&
            <ArticleCard key={article.title} text={article.text[0]} title={article.title} date={article.date}
                         image={article.articleImage} link={article.link} readMore={t("blog:readMore")}/>,
          )}
        </div>
      </Container>
    </Layout>
  );
};

export const getStaticProps = async ({locale}) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common", "index", "blog"])),
  },
});

export default PageIndex;
